import fetchApi from "../fetchApi";
import {DEFAULT_LIMIT} from "../../contstants";
export const GetReports = async (limit = DEFAULT_LIMIT, offset = 0, status) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/company/report?limit=${limit}&offset=${offset}&is_active=${status}`, options);
};